import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IdsModalModule, IdsIconModule, IdsAccordionModule, IdsMainButtonModule, IdsLoadingModule } from '@ids/angular';

import { ContentWrapperModule } from '../content-wrapper/content-wrapper.module';
import { LoaderProfileComponent } from './components/loader-profile/loader-profile.component';
import { GenericErrorComponent } from '../error-treatment/components/generic-error/generic-error.component';
import { NotFoundErrorComponent } from '../error-treatment/components/not-found-error/not-found-error.component';
import { NotAuthenticatedErrorComponent } from '../error-treatment/components/not-authenticated-error/not-authenticated-error.component';
import { ModalContentWrapperComponent } from './components/modal-content-wrapper/modal-content-wrapper.component';

@NgModule({
  declarations: [
    GenericErrorComponent,
    NotFoundErrorComponent,
    NotAuthenticatedErrorComponent,
    LoaderProfileComponent,
    ModalContentWrapperComponent
  ],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    IdsModalModule,
    IdsIconModule,
    IdsAccordionModule,
    IdsMainButtonModule,
    IdsLoadingModule,
    ContentWrapperModule
  ],
  exports: [
    GenericErrorComponent,
    NotFoundErrorComponent,
    ModalContentWrapperComponent,
    NotAuthenticatedErrorComponent,
    LoaderProfileComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CoreModule {}
